import { useReactMediaRecorder } from "react-media-recorder";
import React, { useEffect, useState } from "react"
import { uploadSpecificFile } from "../../core/services/api"
import Button from "../Button"
import { addAudio } from "../../core/services/api/patientDiagnosisService"
import InputField from "components/InputField";

const RecordView = (props: any) => {
  const { setAudioSaved, drawingData, setDrawingData, number, setIsLoading, isReadOnly } = props
  const [second, setSecond] = useState<String | Number>("00")
  const [minute, setMinute] = useState<String | Number>("00")
  const [isActive, setIsActive] = useState(false)
  const [counter, setCounter] = useState(0)
  const [audioName, setAudioName] = useState<any>(`Untitled_${number + 1}`)
  const saveAudio = () => {
    // setIsLoading(true)
    const audio: any = mediaBlobUrl;
    async function createFile() {
      let response = await fetch(audio);
      let data = await response.blob();
      let metadata = {
        type: "audio/wav"
      };
      let file = new File([data], "recording.wav", metadata);
      const formData = new FormData();
      formData.append('files', file);
      uploadSpecificFile(formData, true).then((res) => {
        addAudio(props?.recordId, res?.[0], audioName)
          .then((res) => {
            setAudioSaved(true)
            let temp = { ...drawingData }
            temp["audios"] = res?.audios
            setDrawingData(temp)
            setIsLoading(false)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })

      }).catch((err) => {
        console.log(err)
        setIsLoading(false)
      })

    }
    createFile();
  }
  useEffect(() => {
    let intervalId: any;
    if (isActive) {
      intervalId = setInterval(() => {
        const secondCounter = counter % 60
        const minuteCounter = Math.floor(counter / 60)
        let computedSecond =
          String(secondCounter).length === 1
            ? `0${secondCounter}`
            : secondCounter
        let computedMinute =
          String(minuteCounter).length === 1
            ? `0${minuteCounter}`
            : minuteCounter

        setSecond(computedSecond)
        setMinute(computedMinute)

        setCounter((counter) => counter + 1)
      }, 1000)
    }

    return () => clearInterval(intervalId)
  }, [isActive, counter])

  function stopTimer() {
    setIsActive(false)
    setCounter(0)
    setSecond("00")
    setMinute("00")
  }
  const {
    status,
    startRecording,
    stopRecording,
    pauseRecording,
    mediaBlobUrl,
  } =
    useReactMediaRecorder({
      video: false,
      audio: true,
    })

  const getStatusString = () => {
    if (status) {
      let statusStr = status[0].toUpperCase() + status.slice(1, status?.length)
      return statusStr
    } else {
      return ""
    }
  }

  return (
    <div className="record-view-wrapper">
      <div className="d-flex justify-content-around align-items-center">
        <div style={{ minWidth: "150px" }}>
          <InputField
            type="text"
            placeholder="Enter file name"
            value={audioName}
            handleChange={(e: any) => setAudioName(e?.target?.value)}
            readOnly={isReadOnly}
          />
        </div>
        <div style={{ minWidth: "150px", textAlign: "center" }}>
          <span>{getStatusString()}</span>
        </div>
        <div style={{ minWidth: "150px" }}>
          <audio src={mediaBlobUrl ? mediaBlobUrl : ""} controls loop />
        </div>
        <div style={{ minWidth: "150px", paddingLeft: "20px" }}>
          <span className="minute">{minute}</span>
          <span>:</span>
          <span className="second">{second}</span>
        </div>
      </div >

      <div className="d-flex justify-content-evenly align-items-center mt-2 mb-2">
        <div>
          <Button
            text={isActive ? "Pause" : "Start"}
            onClick={() => {
              if (!isActive) {
                startRecording()
              } else {
                pauseRecording()
              }

              setIsActive(!isActive)
            }}
            id={isActive ? "pause" : "start"}
            disabled={isReadOnly}
          />
        </div>
        <div>
          <Button
            text="Save Audio"
            onClick={() => saveAudio()}
            id="save-audio"
            disabled={(status !== "stopped" ? true : false) || isReadOnly}
          />
        </div>
        <div>
          <Button
            text="Stop"
            onClick={() => {
              stopRecording()
              pauseRecording()
              stopTimer()
            }}
            id="stop"
            disabled={isReadOnly}
          />
        </div>
      </div>
    </div>
  )
}
export default RecordView


